module.exports = __webpack_public_path__ + "static/media/menu3.9be48e91.jpeg";